App = App || {};

App.ManageItems = (function ($, Vue) {
	"use strict";

	function init(rootElement) {
		rootElement = rootElement || document.getElementById("manage-items");
		if (!rootElement || rootElement.dataset.mounted)
			return;

		rootElement.dataset.mounted = true;

		new Vue({
			el: rootElement,
			data: {
				fieldDefs: [
					{ key: "sonaItemNo", label: "SONA #", sortable: true },
					{ key: "soaItemNo", label: "SOA #", sortable: true },
					{ key: "barcode", label: "Barcode", sortable: true },
					{ key: "description", label: "Description", sortable: true },
					{ key: "itemGroup", label: "Group", sortable: true },
					{ key: "purchased", label: "Price Purchased", sortable: false, class: "pl-3" },
					{ key: "earned", label: "Price Earned", sortable: false, class: "pl-3" }
				],
				isLoading: false,
				page: 1,
				pageSize: 10,
				searchTerm: "",
				sortBy: "sonaItemNo",
				sortDesc: false,
				totalItems: 0,
				firstItem: 0,
				lastItem: 0
			},
			computed: {
				fieldsWithColumnSelect: function () {
					var viewModel = this;
					return viewModel.fieldDefs.map((field) => {
						var sortedClass = viewModel.sortBy === field.key ? "is-sorted" : "";
						return Object.assign({}, field, { thClass: sortedClass, tdClass: sortedClass });
					});
				},
				totalPages: function () {
					return Math.max(1, Math.ceil((this.totalItems || 0) / (this.pageSize || 1)));
				}
			},
			methods: {
				provider: function (context) {
					var requestParameters = {
						page: context.currentPage,
						pageSize: context.perPage,
						searchTerm: this.searchTerm || "",
						sortBy: context.sortBy || this.sortBy || "",
						sortDir: (context.sortDesc === true) ? "desc" : "asc"
					};

					return $.ajax({
						url: "/api/items/paged",
						method: "GET",
						dataType: "json",
						data: requestParameters,
						headers: { "Accept": "application/json" },
						timeout: 15000
					}).then((response) => {
						if (response && response.success) {
							context.currentPage = response.data.page;
							context.perPage = response.data.pageSize;
							this.totalItems = response.data.total;
							this.firstItem = response.data.firstItem;
							this.lastItem = response.data.lastItem;
							return response.data.items;
						}

						context.totalItems = 0;
						return [];

					}).catch((error) => {
						console.error("BalanceHistory provider error:", error);
						context.totalItems = 0;
						return [];
					});
				},

				refresh: function () {
					this.page = 1;
					this.$refs.table.refresh();
				},

				redraw: function () {
					this.$refs.table.refresh();
				},

				formatDate: function (value) {
					if (!value)
						return "";

					const normalizedIsoString = String(value).replace(/(\.\d{3})\d+$/, "$1");
					const date = new Date(normalizedIsoString);

					if (isNaN(date))
						return String(value);

					return date.toLocaleDateString("en-US", {
						year: "numeric",
						month: "2-digit",
						day: "2-digit"
					});
				},

				pricesByAspect(item, aspect) {
					const prices = Array.isArray(item?.prices) ? item.prices : [];
					return prices.filter(p => p.aspect === aspect);
				},

				onRowClicked: function (item, index, evt) {
					if (!item || !item.id)
						return;

					if (window.App && App.ItemDetail && App.ItemDetail.open) {
						App.ItemDetail.open(item.id, () => this.redraw());
					}
				},

				itemImportClicked: function () {
					App.ItemImport.open(() => this.refresh());
				},

				serialImportClicked: function () {
					App.SerialImport.open(() => this.refresh());
				}
			},
			mounted: function () {
				this.$nextTick(() => {
					this.$refs.table.refresh();
				});
			}
		});
	}

	return { init: init };
})(jQuery, Vue);

App.ManageItems.init();
